import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./common/print.css";
import { Card, CardBody, CardHeader, Col, Modal, Button, ModalHeader, Row, ModalFooter, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import ReactToPrint from "react-to-print";
import { configuration } from "../appConfig";
import { calculatePrice } from "../pricing/calculatePrice";
import DNSPriceTable from "./common/DNSPriceTable";
import CustomerInfoTable from "./common/CustomerInfoTable";
import CarSVG from "../carbodyparts/CarSvg";
import Select from 'react-select';
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import DetailedReportAuthorization from "./common/DetailedReportAuthorization";
import axios from "axios";
import DnsDamageCarSvg from "../carbodyparts/DnsDamageCarSvg";

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class DetailedReport extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,
    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    priceTotal: [],
    swissTable: [],
    words: {},

    lang: "",
    Authorized: false,
    deAuthLoading: false,
    DATReportAuthorized: false,
    isDATReportAuthorizedKeyExists: false,
    loading: false,
    modal: false,
    name: "",
    Subject: "",
    ActualVin: "",
    jsonData: [],
    sendemail: true,
    options: [],
    seletedoption: [],
    options_CC: [],
    seletedoption_CC: [],
    seletedoption_CCAccounts: [],
    options_CCAccounts: [],
    error: [],
    CCAccountPDFAuthorized: false,
    ccAuthorizedEmail: '',
    modal_dents: false,
    TotalDentCount: "",
    modal_Auth: false,
    isUnviversalScan : 0
  };
  count = [];

  async componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    this.setState({ vinNumber: selectedFile });
    this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
    this.getFallBackDetails();
    // this.getInsurenceClientsEmails();
    // this.setState({
    //   options : [
    //     { value: 'info@adi-gmbh.com', label: 'info@adi-gmbh.com'}
    //   ],
    //   sendemail : partnerId === "1-190301-1" ? false : true,
    // })
  }
  getFallBackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    await axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          this.setState({
            isUnviversalScan : response.data.is_universal_scan
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getInsurenceClientsEmails = () => {
    const partnerId = localStorage.getItem("partnerId");
    const url = configuration.getInsuranceEmails + "?partnerId=" + partnerId;
    Axios.get(url).then((res) => {
      if (res.data.data) {
        let defaultname = res.data.data.Emails && res.data.data.Emails.DefaultAuthorizerName;

        let sendemaill_default = res.data.data.Emails && res.data.data.Emails.SendEmailByDefault == "no" ? false : true;

        let emailresponce = res.data.data.Emails && res.data.data.Emails.to ? res.data.data.Emails.to.map((item) => ({ value: item, label: item })) : [];
        let emailresponce_default = res.data.data.Emails && res.data.data.Emails.toEmailDefault ? res.data.data.Emails.toEmailDefault.map((item) => ({ value: item, label: item })) : [];

        let emailresponce_CC = res.data.data.Emails && res.data.data.Emails.cc ? res.data.data.Emails.cc.map((item) => ({ value: item, label: item })) : [];
        let emailresponce_defaultCC = res.data.data.Emails && res.data.data.Emails.CCEmailDefault ? res.data.data.Emails.CCEmailDefault.map((item) => ({ value: item, label: item })) : [];

        let accounts = res.data.data.ccAccount && res.data.data.ccAccount.CCaccount ? res.data.data.ccAccount.CCaccount.map((item) => ({ value: item, label: item })) : [];
        let accounts_default = res.data.data.ccAccount && res.data.data.ccAccount.CCaccountDefault ? res.data.data.ccAccount.CCaccountDefault.map((item) => ({ value: item, label: item })) : [];

        this.setState({
          name: defaultname,
          sendemail: sendemaill_default,
          seletedoption: [...emailresponce_default],
          seletedoption_CC: [...emailresponce_defaultCC],
          seletedoption_CCAccounts: [...accounts_default],
          options: [...this.state.options, ...emailresponce],
          options_CC: [...this.state.options_CC, ...emailresponce_CC],
          options_CCAccounts: [...this.state.options_CCAccounts, ...accounts]
        });
      }
    });
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  getData = async (selectedFile) => {
    Axios.get(
      `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
    ).then((r) => {
      if (r.data.Authorized) {
        this.setState({
          Authorized: r.data.Authorized,
          ActualVin: r.data.OrderNo ? `${this.lang("Schadennumber")} : ${r.data.OrderNo}` : `${this.lang("Schadennumber")}${""}`,
          Subject: r.data.OrderNo ? `${this.lang("Schadennumber")} : ${r.data.OrderNo}` : `${this.lang("Schadennumber")}${""}`,
          jsonData: r.data,
          Dents: r.data.Dents,
          DATReportAuthorized: r.data.DATReportAuthorized,
          isDATReportAuthorizedKeyExists: r.data.hasOwnProperty("DATReportAuthorized"),
          // CCAccountAuthorizerName: name,
          CCAccountPDFAuthorized: r.data.CCAccountPDFAuthorized,
          TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0"
        }, () => { this.warningMessageForDetailsReport(r.data.Dents) })
      } else {
        this.setState({
          Authorized: false,
          ActualVin: r.data.OrderNo ? `${this.lang("Schadennumber")} : ${r.data.OrderNo}` : `${this.lang("Schadennumber")}${""}`,
          Subject: r.data.OrderNo ? `${this.lang("Schadennumber")} : ${r.data.OrderNo}` : `${this.lang("Schadennumber")}${""}`,
          jsonData: r.data,
          Dents: r.data.Dents,
          DATReportAuthorized: r.data.DATReportAuthorized,
          isDATReportAuthorizedKeyExists: r.data.hasOwnProperty("DATReportAuthorized"),
          CCAccountPDFAuthorized: r.data.CCAccountPDFAuthorized,
          TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0"
        }, () => { this.warningMessageForDetailsReport(r.data.Dents) })
      }
    }).catch(error => alert('An error occured please try again'));
  }

  warningMessageForDetailsReport = (Dents) => {
    // let modalpop = Dents.map((row, index) => {
    //   if((row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside") && row.DentsFromSize == undefined){
    //     Swal.fire({
    //       type: 'info',
    //       icon: 'info',
    //       title: this.lang('attention'),
    //       text: this.lang('Feature is not Supported old Vin'),
    //       confirmButtonText: 'OK',
    //       allowOutsideClick: false
    //     })
    //     .then((result) => {
    //       if (result.value) {
    //         this.props.history.push('/ReportMiniDNS')
    //       }
    //     });
    //   }
    // })
    if (Dents && Array.isArray(Dents)) {
      Dents.forEach((row, index) => {
        if (row && (row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside") && row.DentsFromSize === undefined) {
          Swal.fire({
            type: 'info',
            icon: 'info',
            title: this.lang('attention'),
            text: this.lang('Feature is not Supported old Vin'),
            confirmButtonText: 'OK',
            allowOutsideClick: false
          })
            .then((result) => {
              if (result.value) {
                this.props.history.push('/ReportMiniDNS')
              }
            });
        }
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
        "?partnerId=" +
        partnerId +
        "&vin=" +
        vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
    }
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
      );
      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      } else {
      }
    } else {
      this.props.history.push("/login");
    }
  };
  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    this.customerInfo();
  };
  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;
    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");
    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    for (let i = 0; i < rowArray.length; i++) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      promises.push(Axios.get(url));
    }
    const arrRes = await Axios.all(promises);
    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");
      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
  };
  handleChangeinput = (e) => {
    this.setState({
      [e.target.name]: e.target.name === "name" ? e.target.value.trimStart() : e.target.value
    })
  }

  optionchange = (value) => {
    this.setState({
      seletedoption: value
    })
  }
  optionchange_CC = (value) => {
    this.setState({
      seletedoption_CC: value
    })
  }
  optionchange_CCAccounts = (value) => {
    this.setState({
      seletedoption_CCAccounts: value
    })
  }


  handleSave = () => {
    const { name, Subject } = this.state;
    let error = [];
    if (name == "") {
      error.push("Please enter your name")
    }
    // else if(Subject.trim() == ""){
    //   error.push("Please enter subject")
    // }
    if (error.length) {
      this.setState({
        error: error,
        Modal: true
      })
    } else {
      this.setState({
        error: []
      })
    }
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = configuration.authorizernamestore + `?partnerId=${partnerId}&vin=${vin}&name=${name}&drive_type=${0}`;
    Axios.post(url).then((res) => {
      if (res.data.status === 200) {
        if (!error.length) {
          window.history.pushState(null, "", window.location.href);
          window.onpopstate = function () {
            window.history.pushState(null, "", window.location.href);
          };
          this.authorize();
          this.setState({ modal: false })
        }
      }
    })
  }
  deAuthorize = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;
    this.setState({
      deAuthLoading: true
    })
    this.state.jsonData.Authorized = false
    let payload = {
      ...this.state.jsonData,
      Authorized: false,
      DATReportAuthorized: false,
      AuthorizedName: "",
      ccEmails: ""
    }
    Axios.post(url1, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "De-Authorize PDF successfully!",
      });
      this.setState({
        Authorized: false,
        deAuthLoading: false,
        DATReportAuthorized: false,
        // isDATReportAuthorizedKeyExists:true
      })
      // this.props.updateJsonData(this.state.fullData);
    }).catch(err => {
      this.setState({
        deAuthLoading: false
      })
      alert("Table update failed");
    });
  }
  authorize = () => {
    this.setState({
      modal_Auth: true
    })
    const { jsonData, name, Subject, seletedoption, seletedoption_CC, ActualVin, sendemail } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let autorizeName = name;
    let subject = Subject;
    let SendEmail = sendemail === true ? "yes" : "no"
    let AuthrizeEmail = seletedoption.map((item) => {
      return item.value
    });
    let authrizeEmail_CC = seletedoption_CC.map((item) => {
      return item.value
    });
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading: true
    })
    this.setState({
      jsonData: { ...this.state.jsonData }
    }, async () => {
      let payload = {
        ...this.state.jsonData,
        Authorized: true,
        DATReportAuthorized: false,
        AuthorizedName: this.state.name,
        // DriveThrough : 1,
        ccEmails: [...AuthrizeEmail]
      }
      let payload1 = {
        partnerId,
        vin,
        autorizeName,
        subject,
        AuthrizeEmail,
        report: "mini",
        SendEmail,
        cc: authrizeEmail_CC
      }
      const url = configuration.generateFullReport;
      await Axios.post(url1, { ...jsonData, Authorized: false })
        .then(async (res) => {
          await Axios.post(url, payload1)
            .then((res) => {
              this.state.jsonData.Authorized = true
              if (res.data.status === 200) {
                Axios.post(url1, payload)
                  .then((res) => {
                    this.setState({
                      loading: false,
                      Authorized: true, //for updating local state instantly
                      DATReportAuthorized: false,
                      isDATReportAuthorizedKeyExists: true,
                      modal_Auth: false
                    })
                    this.createDuplicateVin();
                    Toast.fire({
                      type: "success",
                      title: "PDF generated successfully!",
                    });
                    // this.props.updateJsonData(this.state.fullData);
                  }).catch(err => {
                    this.setState({
                      loading: false,
                      modal_Auth: false
                    })
                    // alert("Table update failed");
                    Toast.fire({
                      type: "error",
                      title: "Table update failed",
                    });
                  });
              } else if (res.data.status === 500) {
                this.setState({
                  loading: false,
                })
                // vin or partner Id missing
                Toast.fire({
                  type: "error",
                  title: "Something went wrong!",
                });
              } else {
                this.setState({
                  loading: false,
                })
                Toast.fire({
                  type: "error",
                  title: "pdf generate failed",
                });
              }
              // alert("data updated");
            }).catch(err => {
              this.setState({
                loading: false,
                modal_Auth: false
              })
              Toast.fire({
                type: "error",
                title: "pdf generate failed",
              });
            });
        })
    })

  }

  createDuplicateVin = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { seletedoption_CCAccounts } = this.state;
    let createaccount = seletedoption_CCAccounts.map((item) => {
      return item.value
    });
    const url = configuration.createDuplicateVin;
    let payload = {
      vin: vin,
      main_partnerId: partnerId,
      cc_partnerId: createaccount
    }
    await Axios.post(url, payload)
      .then((res) => {
      })
  }
  showEmail = (e) => {
    this.setState({
      sendemail: e.target.checked
    })
  }
  authorizeCCAccountPDF = () => {
    this.setState({
      modal_Auth: true
    })
    const error = [];
    const { jsonData, name, ccAuthorizedEmail } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    let emailsArr = ccAuthorizedEmail.split(',').map(item => item).filter(item => item !== '');
    if (name == "") {
      error.push("Please enter your name")
    }
    if (error.length) {
      this.setState({
        error: error,
      })
    } else {
      this.setState({
        // modal: false,
        error: [],
        loading: true
      })
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, "", window.location.href);
      };
      const url1 =
        configuration.PostEditorChanges +
        `?partnerId=${partnerId}&vin=${vin}`;

      this.setState({
        loading: true
      })
      this.setState({
        jsonData: { ...this.state.jsonData }
      }, async () => {
        let payload = {
          ...this.state.jsonData,
          CCAccountAuthorizerName: name,
          CCAccountPDFAuthorized: true,
          ccAuthorizedEmail: emailsArr
        }
        let payload1 = {
          partnerId,
          vin,
          autorizeName: name,
          AuthrizeEmail: emailsArr,
          subject: `Schadennummer: ${vin}`,
          report: "mini",
          SendEmail: "yes",
        }
        const url = configuration.generateFullReport;
        await Axios.post(url1, { ...jsonData, CCAccountPDFAuthorized: false })
          .then(async (res) => {
            await Axios.post(url, payload1)
              .then((res) => {
                // this.state.jsonData.Authorized = true

                if (res.data.status === 200) {
                  Axios.post(url1, payload)
                    .then((res) => {
                      this.setState({
                        loading: false,
                        CCAccountAuthorizerName: name,
                        CCAccountPDFAuthorized: true,
                        name: '',
                        modal: false,
                        modal_Auth: false
                      })
                      Toast.fire({
                        type: "success",
                        title: "PDF generated successfully!",
                      });
                    }).catch(err => {
                      this.setState({
                        loading: false,
                        modal: false,
                        CCAccountAuthorizerName: name,
                        CCAccountPDFAuthorized: false,
                        modal_Auth: false
                      })
                      Toast.fire({
                        type: "error",
                        title: "Table update failed",
                      });
                    });
                } else if (res.data.status === 500) {
                  this.setState({
                    loading: false,
                  })
                  // vin or partner Id missing
                  Toast.fire({
                    type: "error",
                    title: "Something went wrong!",
                  });
                } else {
                  this.setState({
                    loading: false,
                  })
                  Toast.fire({
                    type: "error",
                    title: "pdf generate failed",
                  });
                }
                // alert("data updated");
              }).catch(err => {
                this.setState({
                  loading: false,
                  modal_Auth: false
                })
                Toast.fire({
                  type: "error",
                  title: "pdf generate failed",
                });
              });
          })
      });
    }


  }


  render() {
    const { orderNumber } = this.state.order;
    const partnerId = localStorage.getItem("partnerId");
    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      <DetailedReportAuthorization />
                      {/* {(partnerId === "8-200406-1" || partnerId === "deutz-ulm" || partnerId === "HXAG-01" || partnerId === "1-190301-1" || partnerId === "6-200406" || partnerId === "002-sa"
                        || partnerId === "16-220515" || partnerId === "WW-001" || partnerId === "demo-de" || partnerId === "23-230315" || partnerId === "23-230315-1") &&
                        <>
                          {this.state.isDATReportAuthorizedKeyExists && (
                            <button
                              className={`glass btn btn-lg btn-danger mr-1`}
                              disabled={!this.state.Authorized}
                              // className="glass btn btn-lg btn-danger pull-right"
                              onClick={() => this.deAuthorize()}
                            >
                              {this.state.deAuthLoading ?
                                <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                  <span className="sr-only">Loading...</span>
                                </div>
                                :
                                <i className="fa fa-file-text-o" />
                              }
                              &nbsp; {this.lang("De-Authorize PDF")}
                            </button>
                          )}
                          {
                            (localStorage.getItem("partnerId_new") != 'null' && localStorage.getItem("partnerId_new")) ?
                              <button
                                disabled={this.state.loading || this.state.CCAccountPDFAuthorized}
                                className={`glass btn btn-lg  ${this.state.CCAccountPDFAuthorized ? 'btn-success' : 'btn-danger'} mr-1`}
                                // className="glass btn btn-lg btn-danger pull-right"
                                //  onClick={this.authorize}
                                // onClick={() => this.setState({modal : true})}
                                onClick={() => this.state.TotalDentCount == 0 ? this.setState({ modal_dents: true }) : this.setState({ modal: true })}
                              >
                                {this.state.loading ?
                                  <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                  :
                                  <i className="fa fa-file-text-o" />
                                }
                                &nbsp; {this.lang("Authorize PDF")}
                              </button>
                              :

                              <button
                                disabled={this.state.loading || this.state.Authorized}
                                className={`glass btn btn-lg  ${this.state.Authorized ? 'btn-success' : 'btn-danger'} mr-1`}
                                // className="glass btn btn-lg btn-danger pull-right"
                                //  onClick={this.authorize}
                                // onClick={() => this.setState({modal : true})}
                                onClick={() => this.state.TotalDentCount == 0 ? this.setState({ modal_dents: true }) : this.setState({ modal: true })}
                              >
                                {this.state.loading ?
                                  <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                  :
                                  <i className="fa fa-file-text-o" />
                                }
                                &nbsp; {this.lang("Authorize PDF")}
                              </button>
                          }
                        </>} */}
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="glass btn btn-lg btn-danger">
                              <i className="fa fa-print" />
                              &nbsp; {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <div
            className="container reportmini all-reports-top-wrapper"
            // id="divIdToPrint"
            ref={(el) => (this.componentRef = el)}
            style={{ padding: 0 }}
          >
            <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      {/* <ReportHeader /> */}
                      <ReportHeader_Swiss />
                      {/* <div className="p-0 row "> */}
                      <CustomerInfoTable />
                      {/* <Newswiss_CustomerInfoTable/> */}
                      <div className="fullview_main_table_wrapper_inner">
                        <DNSPriceTable is_extra_columns_dentsize_show={true}
                          vinfolderList={
                            this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT &&
                            this.state.vinfolderList[0].resultTXT.scanresult
                          }
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss />
                </Card>
              </div>
            </div>
            <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container car-svg-main">
                        <div className="row title-row-main">
                          <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                              {this.lang("2D")}<span> {this.lang("View")} </span>
                            </h3>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                          {
                              this.state.isUnviversalScan == 1 ?
                              <DnsDamageCarSvg {...this.props}/> :
                            <CarSVG {...this.props} />
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss />
                </Card>
              </div>
            </div>
          </div>
          {/* <div>
            <Card>
              <CardBody>
                <Link className="glass" to="/ReportFull">
                  <button className="btn btn-danger btn-sm pull-right">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
                <Link className="glass" to="/TabView">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn btn-danger btn-sm pull-right"
                  >
                    {"<<"} <i className="fa fa-dot-circle-o"></i>
                  </button>
                </Link>
              </CardBody>
            </Card>
          </div> */}

          <Modal size="lg" isOpen={this.state.modal} className="authorizer_emailsend_modal" backdrop="static"
            toggle={() => this.setState({ modal: false })}
          >
            <ModalBody>
              {(localStorage.getItem("partnerId_new") != 'null' && localStorage.getItem("partnerId_new")) ?
                <form>
                  <div className="form_group mb-2">
                    <label className="mb-1">{this.lang("Authorizer name")}</label>
                    <input className="form-control" placeholder={this.lang("Authorizer name")} type="text"
                      name="name"
                      value={this.state.name}
                      onChange={(e) => this.handleChangeinput(e)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                          this.authorizeCCAccountPDF()
                        }
                      }}
                    />
                    {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}

                  </div>
                  <div className="form_group mb-2">
                    <label className="mb-1">{this.lang("CC Email Address")}</label>
                    <input
                      className="form-control"
                      placeholder={this.lang("CC Email Address")}
                      type="text"
                      name="ccAuthorizedEmail"
                      value={this.state.ccAuthorizedEmail}
                      onChange={(e) => this.handleChangeinput(e)}
                      onKeyPress={(e) => {
                        // if (e.key === 'Enter') {
                        //   e.preventDefault()
                        //   this.authorizeCCAccountPDF()
                        // }
                      }}
                    />
                    {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}
                  </div>
                </form>
                :
                <form>
                  <div className="form_group mb-2">
                    <label className="mb-1">{this.lang("Authorizer name")}</label>
                    <input className="form-control" placeholder={this.lang("Authorizer name")} type="text"
                      name="name"
                      value={this.state.name}
                      onChange={(e) => this.handleChangeinput(e)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                          this.handleSave()
                        }
                      }}
                    />
                    {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}
                  </div>
                  <div className="form_group mb-2">

                    <label className="mb-1">{this.lang("Subject")}</label>
                    <input className="form-control"
                      type="text"
                      name="Subject"
                      value={this.state.Subject}
                      onChange={(e) => this.handleChangeinput(e)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                          this.handleSave()
                        }
                      }}
                    />
                  </div>
                  {/* {this.state.error.includes('Please enter subject') && <span style={{color : "red"}}>{this.lang("Please enter subject")}</span>} */}
                  <div className="form_group mb-2">
                    <div className="d-flex justify-content-between mb-2 align-items-center">
                      <div>
                        <label className="mb-0">{this.lang("Email Address")}</label>
                      </div>
                      <div className="main-wrapper-switch-lab-modal">
                        <div className="admin-list report_switch_wrapper">
                          <label className="name">{this.lang("SendEmail")}</label>
                          <label className="switch">
                            <input className="switch-input" type="checkbox" name="sendemail" id="sendemail" value={this.state.sendemail} onClick={(e) => this.showEmail(e)} checked={this.state.sendemail} />
                            <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                            <span className="switch-handle"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <Select
                      className="email_address_selection"
                      closeMenuOnSelect={false}
                      onChange={this.optionchange}
                      // defaultValue={[this.state.options[0], this.state.options[1], this.state.options[2]]}
                      defaultValue={this.state.seletedoption}
                      isMulti
                      options={this.state.options}
                    />
                    <div className="form_group mb-2 mt-2">
                      <label className="name mb-2">{this.lang("CC Email Address")}</label>
                      <Select
                        className="email_address_selection"
                        closeMenuOnSelect={false}
                        onChange={this.optionchange_CC}
                        // defaultValue={[this.state.options[0], this.state.options[1], this.state.options[2]]}
                        defaultValue={this.state.seletedoption_CC}
                        isMulti
                        options={this.state.options_CC}
                      />
                    </div>
                    <div className="form_group mb-2 mt-2">
                      <label className="name mb-2">{this.lang("CCAccounts")}</label>
                      <Select
                        className="email_address_selection"
                        closeMenuOnSelect={false}
                        onChange={this.optionchange_CCAccounts}
                        // defaultValue={[this.state.options[0], this.state.options[1], this.state.options[2]]}
                        defaultValue={this.state.seletedoption_CCAccounts}
                        isMulti
                        options={this.state.options_CCAccounts}
                      />
                    </div>


                  </div>
                </form>
              }
            </ModalBody>
            <ModalFooter>
              <div>
                <Button className="btn btn-cancel  p-2 mr-2" onClick={() => this.setState({ modal: false })}> {this.lang("Cancel")} </Button>
                <Button className="btn p-2 btn-danger" onClick={() => { (localStorage.getItem("partnerId_new") != 'null' && localStorage.getItem("partnerId_new")) ? this.authorizeCCAccountPDF() : this.handleSave() }}> {this.lang("Save")} </Button>
              </div>
            </ModalFooter>
          </Modal>

          <Modal centered size="md" isOpen={this.state.modal_dents} className="dent_zero_modal" backdrop="static"
            toggle={() => this.setState({ modal_dents: false })}>
            <ModalBody className="text-center">
              <p className="mb-3 text-message-extra-image"><b>{this.lang("The total number of dents is 0. Would you still like to authorize.")}</b></p>
              <button className="btn btn-danger p-2 mr-2" onClick={() => this.setState({ modal: true, modal_dents: false })}> {this.lang("Yes")} </button>
              <button className="btn btn-cancel p-2" onClick={() => this.setState({ modal_dents: false })}> {this.lang("No")} </button>
            </ModalBody>
          </Modal>

          <Modal centered size="lg" isOpen={this.state.modal_Auth} className="authorise_modalpopup" backdrop="static"
            toggle={() => this.setState({ modal_Auth: false })}>
            <ModalBody className="text-center">
              <p className="mb-3 text-message-extra-image"><b>{this.lang("Please wait Authorization in progress")}<span className="dot-flashing"></span></b></p>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}
